import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import { Grid, GridCell } from 'rmwc/Grid';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { Select } from 'rmwc/Select';
import {Button} from 'rmwc/Button';

import StatusMessage from '../..//util/StatusMessage'

class CoursePackageLanding extends Component{


  constructor(props){
    super(props);
    this.state={
      errorMsg: '',
      data: {
        purchaseEntities: [],
        selectedEntityId: '',
      },
    }
  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    return api.getPurchaseEntities(this.props.user.accessToken)
      .then((result) => {
        if(result.status === 'success') {
          data.purchaseEntities = result.data
        }
        this.setState({data: data})
      })
  }

  
  handlePurchaseEntity = (e) => {
    let data = Object.assign({}, this.state.data)
    data.selectedEntityId = e.target.value
    this.setState({data: data})
  }


  handlePartnerSelectionNext =(e) =>{
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    console.log(this.state.data.selectedEntityId)
    if(this.state.data.selectedEntityId === undefined || this.state.data.selectedEntityId === ''){
      console.log('inside if')
      this.setState({errorMsg: 'Please select Affiliated Partner from dropdown before proceeding'})
    }
    else{
      console.log('inside else')
      let purchaseHomeUrl = '/portal/app/purchase/home/' + this.state.data.selectedEntityId
      this.props.history.push(purchaseHomeUrl)
    }
    
  }

	render() {
    let purchaseEntityComponent

    purchaseEntityComponent = (
     <Select 
        name="country"
        onChange={this.handlePurchaseEntity}
        value={this.state.data.selectedEntityId}
        
      >
        <option value="" selected="">--Select Affiliated Partner--</option>
        {this.state.data.purchaseEntities.map(entity => (
          <option key={entity.id} value={entity.id}>
            {entity.name}
          </option>
        ))}
      </Select>
    )

		return (
			<div hidden>
        <Card style={{padding: '10px'}}>
        <Grid>
          <GridCell span="12">
            <Typography use="headline5">Affiliated Program</Typography>
          </GridCell>
        </Grid>
				</Card>
        <Grid>

          <GridCell span="1"/>
          <GridCell span="11">
            <Typography use="subtitle">Please select from the list of Affiliate Parnters and click on Next</Typography>
          </GridCell>
          
          <GridCell span="2"/>
          <GridCell span="6">
            {purchaseEntityComponent}
          </GridCell>
          <GridCell span="4"/>

          <GridCell span="3"/>
          <GridCell span="3">
            <Button onClick={this.handlePartnerSelectionNext}>Next</Button>
          </GridCell>
          <GridCell span="6"/>

          <GridCell span="2"/>

          <GridCell span="10"> <StatusMessage error_msg = {this.state.errorMsg}/> </GridCell>
        
        </Grid>
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(CoursePackageLanding);


// WEBPACK FOOTER //
// ./src/views/purchases/CoursePackageLanding.jsx